import { useEffect, useState } from "react";
import { connect } from "react-redux";

import {
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Spin,
  TimePicker,
} from "antd";

import { capitalize } from "lodash";
import RelationField from "./formItems/RelationField";
import SingleUpload from "./SingleUpload";
import dayjs from "dayjs";
import CustomSelect from "./hoc/CustomSelect";

const getSortArray = (item, formData) => {
  const filteredFields = item.filter((field) => {
    if (!!field.visibility_depends_on) {
      if (field.visibility_condition) {
        if (
          field.visibility_value?.includes(
            formData[`${field.visibility_depends_on}`]
          )
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        if (
          !field?.visibility_value.includes(formData["visibility_depends_on"])
        ) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return true;
    }
  });
  console.log(filteredFields);
  return filteredFields;
};

function getDefaultValues(data) {
  if (data) {
    const defaultValues = {};

    data.forEach((field) => {
      if (field.default) {
        defaultValues[field.title] = field.default;
      }
    });

    return defaultValues;
  }
}

const renderField = (form, field = {}, nameArray) => {
  return (
    <Form.Item
      name={field.title}
      label={
        field.display ?? capitalize(field.title?.replaceAll("_", " ") ?? "")
      }
      extra={!!field.detail && <p>{field.detail}</p>}
      hidden={field.hidden}
      rules={[
        {
          required: field.required,
          message: `Missing ${field.title}`,
        },
      ]}
      getValueProps={
        field.inputType === "datepicker" || field.inputType === "timepicker"
          ? (value) => {
              return {
                value: value
                  ? dayjs(
                      value,
                      field.inputType === "datepicker"
                        ? "YYYY-MM-DDTHH:mm:ss.SSSZ"
                        : "HHmmss"
                    )
                  : null,
              };
            }
          : null
      }
      getValueFromEvent={
        field.inputType === "datepicker" || field.inputType === "timepicker"
          ? (value) =>
              value &&
              value.format(
                field.inputType === "datepicker"
                  ? "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  : "HHmmss"
              )
          : null
      }
    >
      {field.inputType === "text" && (
        <Input placeholder={field.placeholder} disabled={field.readOnly} />
      )}

      {field.inputType === "number" && (
        <InputNumber
          style={{ width: "100%" }}
          placeholder={field.placeholder}
          disabled={field.readOnly}
        />
      )}
      {field.inputType === "textarea" && (
        <Input.TextArea
          placeholder={field.placeholder}
          disabled={field.readOnly}
          autoSize={{ minRows: 2, maxRows: field.disabled ? 100 : 10 }}
        />
      )}

      {/* Media */}
      {field.inputType === "media" && <SingleUpload />}

      {/* Media */}

      {field.inputType === "datepicker" && (
        <DatePicker
          style={{ width: "100%" }}
          // disabledDate={(current) => {
          //   return current && current < dayjs().startOf("day");
          // }}
          showTime={field.showTime}
          format={field.format ?? "YYYY-MM-DD HH:mm:ss"}
          placeholder={field.placeholder}
        />
      )}
      {field.inputType === "select" && (
        <CustomSelect
          mode={field.relationType === "multiple" ? "multiple" : undefined}
          placeholder={field.placeholder}
          options={
            field.options?.split(",")?.map((i) => ({
              label: i,
              value: i,
            })) ?? []
          }
        />
      )}
      {field.inputType === "boolean" && (
        <CustomSelect
          // onChange={(e) =>
          //   setData({
          //     key: `${item.key}_${field.key}`,
          //     value: e,
          //   })
          // }
          placeholder={field.placeholder}
          options={[
            { label: "True", value: true },
            { label: "False", value: false },
          ]}
        />
      )}
      {field.inputType === "timepicker" && (
        <TimePicker
          style={{ width: "100%" }}
          format="hh:mm A"
          placeholder={field.placeholder}
        />
      )}

      {(field.inputType === "relation" || field.inputType === "attribute") && (
        <RelationField item={field} form={form} />
      )}
    </Form.Item>
  );
};

export const CustomForm = ({
  formData,
  form,
  onFormSubmit,
  refresh = 0,
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState(false);

  useEffect(() => {
    if (refresh != 0) setFormValues(form.getFieldsValue());
  }, [refresh]);

  useEffect(() => {
    if (formData) {
      const isEdit = form.getFieldValue("isFormEdit");
      const defaultValues = getDefaultValues(formData);
      if (!isEdit) form.setFieldsValue({ ...defaultValues });
      setFormValues(form.getFieldsValue());
    }
  }, [formData]);

  if (loading)
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <Spin />
      </div>
    );

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFormSubmit}
      hideRequiredMark
      onValuesChange={(_, values) =>
        setFormValues((prev) => ({ ...prev, ...values }))
      }
      {...props}
    >
      <Row gutter={16}>
        <Form.Item name="isFormEdit" hidden={true}></Form.Item>
        <Form.Item name="uniId" hidden={true}></Form.Item>

        {getSortArray(formData, formValues)?.map((item) => (
          <Col span={item.span ?? 24}>{renderField(form, item)}</Col>
        ))}
      </Row>
    </Form>
  );
};

const mapStateToProps = (state) => ({
  // formData: state?.cms?.formData ?? [],

  dropdownData: state?.cms ?? {},
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CustomForm);
